module.exports = __webpack_public_path__ + "img/bg-mountains.9b9edde8.png";